import { render } from "./AppChip.vue?vue&type=template&id=7e913742&scoped=true&lang=pug"
import script from "./AppChip.vue?vue&type=script&lang=js"
export * from "./AppChip.vue?vue&type=script&lang=js"

import "./AppChip.vue?vue&type=style&index=0&id=7e913742&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e913742"]])

export default __exports__